import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const Stats = () => {
  const { t } = useLanguage();

  return (
    <div className="stats-bar">
      {t.stats.map((stat) => (
        <div className="stat-item" key={stat.val}>
          <div className="stat-val">{stat.val}</div>
          <div className="stat-lbl">{stat.label[0]}<br />{stat.label[1]}</div>
        </div>
      ))}
    </div>
  );
};

export default Stats;
